import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Create, Toolbar, ToolbarProps, useNotify, useRefresh } from "react-admin";
import { useTranslate } from "react-admin";

import { useErrorHandler } from "../hooks/useErrorHandler";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { color } from "../theme/designTokens";
import { BaseModalProps } from "../types/modal";
import { CloseButton, SaveButton } from "./buttons";
import { LocationForm, LocationFormData } from "./LocationForm";

const LocationCreateToolbar = (props: ToolbarProps & { onCancel: () => void }) => {
  const { onCancel, ...toolbarProps } = props;

  return (
    <Toolbar {...toolbarProps}>
      <SaveButton />
      <CloseButton onClick={onCancel} />
    </Toolbar>
  );
};

const LocationCreate = ({ open, onClose }: BaseModalProps) => {
  const { organizationId } = useOrganizationContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const handleError = useErrorHandler();
  const translate = useTranslate();

  const handleTransform = (data: LocationFormData) => {
    if (!organizationId) {
      throw new Error(translate("create.noOrganizationSelected"));
    }

    return {
      ...data,
      organizationId,
    };
  };

  const handleSuccess = () => {
    notify("create.location.success", { type: "success" });
    refresh();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ backgroundColor: color.background }}>{translate("create.location.title")}</DialogTitle>
      <DialogContent>
        <Create
          resource="Location"
          transform={handleTransform}
          mutationOptions={{
            onError: error => handleError(error, translate("create.location.error")),
            onSuccess: handleSuccess,
          }}
        >
          <LocationForm toolbar={<LocationCreateToolbar onCancel={onClose} />} />
        </Create>
      </DialogContent>
    </Dialog>
  );
};

export default LocationCreate;
